<template>
  <div class="home_img_ZDY" v-loading.body="loading" style="min-height: 650px;">
    <div v-for="(itemlabel,index) in layout_page_managementlist" :key="index">
      <div class="oneblock" v-if="itemlabel.label=='KTZFZRJS0'&&itemlabel.is_hide==0">
        <div :style="{'width':introduction_research_areas?'':'100%'}"
          class="lingyucontainer"
          v-if="introduction_research_areas_KTZFZR"
        >
          <div class="jianjiecontainer_block">
            <div class="title_hover_line_lang" :style="{'background-color':all_app_color}"></div>
            <div
              v-if="isloginADorGU=='AD'||isloginADorGU=='SAD'"
              v-show="isshowxiugai"
              class="xiugai iconfont icon-xiugai"
              @click="toprincipalIntroduce"
              :style="{'color':all_app_color}"
            ></div>
            <div v-show="!isshowxiugai" class="lookmore lookmore_span_position">
              <span
                :style="{'color':all_app_color}"
                @click="toprincipalIntroduce"
                v-show="!isshowxiugai"
                style="margin-right:5px;"
              >{{$t('lang.more')}}>></span>
            </div>
            <div class="title_bottom_line_hui"></div>
            <div class="titletop">
              <div class="title_bottom_line" :style="{'background-color':all_app_color}"></div>
              <i
                class="iconfont icon-yj_fx title_icon"
                :style="{'color':all_app_color}"
                style="font-weight: 600;"
              ></i>
              <!-- <div class="title">{{$t('lang.principalIntroduce')}}</div> -->
              <div class="title">{{itemlabel.name}}</div>
              <!-- <div class="titlefu">{{$t('lang.principalIntroduce')}}</div> -->
            </div>
          </div>

          <div class="textcontent">
            <div style="display:flex;margin-top: 35px;">
              <div>
                <div class="FZRJS_font">
                  <img
                    class="img_width_height"
                    :src="introduction_research_areas_KTZFZR.photo[0]"
                    alt
                  />
                  <div class="maxscreenblock" style="margin-bottom:10px;">
                    <span class="name_font">{{introduction_research_areas_KTZFZR.name}}</span>
                    <span
                      style="font-size: 14px;color:#999;margin-left:20px;"
                    >{{introduction_research_areas_KTZFZR.job_title}}</span>
                  </div>
                  <div class="minscreenblock" style="margin-bottom:10px;">
                    <span class="name_font">{{introduction_research_areas_KTZFZR.job_title}}</span>
                  </div>
                  <div class="minscreenblock" style="margin-bottom:10px;">
                    <span
                      style="font-size: 14px;color:#999;"
                    >{{introduction_research_areas_KTZFZR.name}}</span>
                  </div>
                  <span
                    style=" text-indent: 2em;"
                  >{{introduction_research_areas_KTZFZR.biography|deletehtmltext}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="jianjiecontainer"
          v-if="introduction_research_areas"
        >
          <div class="jianjiecontainer_block">
            <div class="title_hover_line_lang" :style="{'background-color':all_app_color}"></div>
            <div
              v-if="isloginADorGU=='AD'||isloginADorGU=='SAD'"
              v-show="isshowxiugai"
              :style="{'color':all_app_color}"
              class="xiugai iconfont icon-xiugai"
              @click="goHtIndex('ht_ktzjs')"
            ></div>
            <div v-show="!isshowxiugai" class="lookmore lookmore_span_position">
              <span
                :style="{'color':all_app_color}"
                @click="toktzintroduce"
                v-show="!isshowxiugai"
                style="margin-right:5px;"
              >{{$t('lang.more')}}>></span>
            </div>
            <div class="title_bottom_line_hui"></div>
            <div class="titletop">
              <div class="title_bottom_line" :style="{'background-color':all_app_color}"></div>
              <i class="iconfont icon-ktz_js title_icon" :style="{'color':all_app_color}"></i>
              <!-- <div class="title">{{$t('lang.Introduction_to_the_research_group')}}</div>
              <div class="titlefu">{{$t('lang.Introduction_to_the_research_group_zh')}}</div>-->
              <div class="title"  v-show="itemlabelss.label=='KTZJS0000'" v-for="(itemlabelss,index) in layout_page_managementlist" :key="index">{{itemlabelss.name}}</div>
            </div>
          </div>

          <div class="textcontent">
            <p>{{introduction_research_areas.introduction}}</p>
          </div>
        </div>
      </div>

      <div class="dongtaicontainer" v-if="itemlabel.label=='DTZS00000'&&itemlabel.is_hide==0">
        <div class="zongtitle jianjiecontainer_block">
          <div class="title_hover_line_lang" :style="{'background-color':all_app_color}"></div>
          <div class="line"></div>
          <div class="title_top_min_block">
            <div class="title_bottom_line" :style="{'background-color':all_app_color}"></div>
            <i class="iconfont icon-dt_dt title_icon" :style="{'color':all_app_color}"></i>

            <!-- <div class="titletext">{{$t('lang.dynamic')}}</div>
            <div class="titletextfu">{{$t('lang.dynamic_zh')}}</div>-->
            <div class="titletext">{{itemlabel.name}}</div>
          </div>

          <div
            v-if="isloginADorGU=='AD'||isloginADorGU=='SAD'"
            v-show="isshowxiugai"
            class="tuxiugai iconfont icon-xiugai"
            @click="goHtIndex('ht_dt')"
            :style="{'color':all_app_color}"
          ></div>
          <div v-show="!isshowxiugai" class="lookmore lookmore_span_position">
            <span :style="{'color':all_app_color}" @click="todynamic_inti">{{$t('lang.more')}}>></span>
          </div>
        </div>
        <div v-if="xinwen" class="xinwencontainer">
          <div class="xinwen">
            <div class="xinwentop">
              <div class="linewor" :style="{'background-color':all_app_color}"></div>
              <div class="xinwentitle">{{xinwentitle}}</div>
            </div>
            <div class="xinwenbottom">
              <div
                v-show="index<3"
                @click="todynamicDetails(item.id)"
                class="xinwenzhongjianbottom_hover"
                v-for="(item,index) in xinwen"
                :key="index"
              >
                <p class="onep">{{item.title}}</p>
                <p class="twop iconfont icon-shijian" style="position:relative;overflow: hidden;">
                  {{item.publish_date}}
                  <span class="dt_position_line"></span>
                </p>
              </div>
              <div v-show="liangzhong_dt" class="lookmore">
                <span
             
                  :style="{'color':all_app_color}"
                  @click="todynamic(xinwentitle)"
                >{{$t('lang.more')}}>></span>
              </div>
            </div>
          </div>
          <div v-if="xinwenzhongjian" class="xinwenzhongjian">
            <div
              class="zuneitop zuneitopzhong"
              v-show="xinwenzhongjiantitle||xinwenzhongjian_no_content"
            >
              <div
                class="linewor"
                :style="{'background-color':all_app_color}"
                v-show="xinwenzhongjiantitle"
              ></div>
              <div class="zuneititle">{{xinwenzhongjiantitle}}</div>
            </div>
            <div class="xinwenzhongjianbottom">
              <div
                class="xinwenzhongjianbottom_hover"
                v-show="index<3"
                @click="todynamicDetails(item.id)"
                v-for="(item,index) in xinwenzhongjian"
                :key="index"
              >
                <p class="onep">{{item.title}}</p>

                <p class="twop iconfont icon-shijian" style="position:relative;overflow: hidden;">
                  {{item.publish_date}}
                  <span class="dt_position_line"></span>
                </p>
              </div>
              <div class="lookmore" v-show="yizhong_dt">
                <span
                  :style="{'color':all_app_color}"
                
                  @click="todynamic(xinwenzhongjiantitle)"
                >{{$t('lang.more')}}>></span>
              </div>
            </div>
          </div>
          <div v-if="zunei" class="zunei">
            <div class="zuneitop" v-show="zunei_no_content||zuneititle">
              <div class="linewor" :style="{'background-color':all_app_color}" v-show="zuneititle"></div>
              <div class="zuneititle">{{zuneititle}}</div>
            </div>
            <div class="zuneibottom">
              <div
                v-show="index<3"
                @click="todynamicDetails(item.id)"
                class="xinwenzhongjianbottom_hover"
                v-for="(item,index) in zunei"
                :key="index"
              >
                <p class="onep">{{item.title}}</p>

                <p class="twop iconfont icon-shijian" style="position:relative;overflow: hidden;">
                  {{item.publish_date}}
                  <span class="dt_position_line"></span>
                </p>
              </div>
              <div v-show="sanzhong_dt" class="lookmore">
                <span
                  :style="{'color':all_app_color}"
                  @click="todynamic(zuneititle)"
                >{{$t('lang.more')}}>></span>
              </div>
            </div>
          </div>
        </div>
         <div v-else style="margin-top:30px;margin-bottom:30px;text-align: left;margin-right: auto;justify-content: left;" class="xinwencontainer jianjiecontainer_block ">暂无数据</div>
      </div>

      <div
        class="chengyuancontainer"
        v-if="itemlabel.label=='CYZS00000'&&itemlabel.is_hide==0&&index_member_list"
      >
        <div class="zongtitle jianjiecontainer_block">
          <div class="title_hover_line_lang" :style="{'background-color':all_app_color}"></div>
          <div class="line"></div>
          <div class="title_top_min_block">
            <div class="title_bottom_line" :style="{'background-color':all_app_color}"></div>
            <i class="iconfont icon-cy_js title_icon" :style="{'color':all_app_color}"></i>
            <!-- <div class="titletext">{{$t('lang.member_introduction')}}</div>
            <div class="titletextfu">{{$t('lang.member_introduction_zh')}}</div>-->
            <div class="titletext">{{itemlabel.name}}</div>
          </div>
          <div
            v-if="isloginADorGU=='AD'||isloginADorGU=='SAD'"
            v-show="isshowxiugai"
            class="tuxiugai iconfont icon-xiugai"
            @click="goHtIndex('ht_cyjs')"
            :style="{'color':all_app_color}"
          ></div>
          <div v-show="!isshowxiugai" class="lookmore lookmore_span_position">
            <span :style="{'color':all_app_color}" @click="toteamintroduction">{{$t('lang.more')}}>></span>
          </div>
        </div>
        <div v-if="index_member_list.length!=0"  class="chengyuancentent">
          <div
            class="chengyuanlist"
            @click="tomember(item.user_id,item.link_suffix)"
            v-for="(item,index) in index_member_list"
            :key="index"
          >
            <div class="chengyuanlist_img_hover_hidden">
              <img v-if="item.photo&&item.photo.length>=0" :src="item.photo[0]" />
            </div>
            <el-tooltip placement="top">
              <div slot="content">
                <div style="max-width:300px; white-space:wrap;text-align:center;">{{item.name}}</div>
              </div>
              <p class="chengyuanlist_container">{{item.name}}</p>
            </el-tooltip>
            <p class="huicolortext">{{item.user_identity}}</p>
          </div>
        </div>
         <div v-else style="margin-top:30px;margin-bottom:30px;text-align: left;margin-right: auto;justify-content: left;" class="chengyuancentent jianjiecontainer_block ">暂无数据</div>
      </div>

      <div
        class="chengguocontainer"
        v-if="itemlabel.label=='CGZS00000'&&itemlabel.is_hide==0&&index_research_results_list"
      >
        <div class="zongtitle jianjiecontainer_block">
          <div class="title_hover_line_lang" :style="{'background-color':all_app_color}"></div>
          <div class="line"></div>
          <div class="title_top_min_block">
            <div class="title_bottom_line" :style="{'background-color':all_app_color}"></div>
            <i class="iconfont icon-cg_zs title_icon" :style="{'color':all_app_color}"></i>
            <!-- <div class="titletext">{{$t('lang.achievement_exhibition')}}</div>
            <div class="titletextfu">{{$t('lang.achievement_exhibition_zh')}}</div>-->
            <div class="titletext">{{itemlabel.name}}</div>
          </div>
          <div
            v-if="isloginADorGU=='AD'||isloginADorGU=='SAD'"
            v-show="isshowxiugai"
            class="tuxiugai iconfont icon-xiugai"
            @click="goHtIndex('ht_cgzs')"
            :style="{'color':all_app_color}"
          ></div>
          <div class="lookmore lookmore_span_position">
            <span
              v-show="!isshowxiugai"
              @click="toresearchprogress"
              class="chengguomore"
              :style="{'color':all_app_color}"
            >{{$t('lang.more')}}>></span>
          </div>
        </div>

        <div v-if="index_research_results_list.length!=0"
          class="chengguocentent_wai_block_pois_rela"
          @mouseenter="on_bot_enter"
          @mouseleave="on_bot_leave"
        >
          <swiper
            class="swiImgs"
            ref="swiImgs"
            :options="swiperOption"
            v-if="index_research_results_list.length>0"
          >
            <swiper-slide
              @touchmove.native="stopPlay"
              @touchend.native="play"
              v-for="(item,index) in index_research_results_list"
              data-index="index"
              :key="index"
              :slidesPerView="3"
              class="chengguocentent"
            >
              <i
                class="iconfont icon-huixinzheng huixinzheng_cg_position"
                :style="{'color':all_app_color}"
              ></i>
              <div
                class="chengguocentent_mubu"
                :style="{'background-image':'url('+item.pic+')'}"
                @click="toyanjiujinzhanxiangqingye(item.result_id,item.type)"
              >
                <span class="chengguocentent_mubu_rongyu_label">
                  {{item.type_name}}
                  <!-- <span>{{item.source}}</span> -->
                </span>
                <div class="righttext">
                  <div class="chengguotop">
                    <span class="chengguotopcontainer">{{item.title}}</span>
                  </div>
                  <div class="chengguobottom" style="margin-bottom:5px;">
                    <span>{{item.author_name}}</span>
                  </div>
                  <div class="chengguocentent_mubu_text_time LWsource_div">
                   <span class="LWsource">{{item.source}} </span>
                  </div>
                  <div class="chengguocentent_mubu_text_time ">
                <span>{{item.publish_date}}</span>
                  </div>
                </div>
              </div>
            </swiper-slide>
          </swiper>

          <div class="swiper-button-next iconfont icon-zuo"></div>

          <div class="swiper-button-prev iconfont icon-you"></div>
        </div>
        <div v-else style="margin-top:30px;margin-bottom:30px;text-align: left;margin-right: auto;justify-content: left;" class="jianjiecontainer_block chengguocentent_wai_block_pois_rela">暂无数据</div>
      </div>

      <div
        class="keyancontainer"
        v-if="itemlabel.label=='KYSB00000'&&itemlabel.is_hide==0&&index_equipment_list"
      >
        <div class="zongtitle jianjiecontainer_block">
          <div class="title_hover_line_lang" :style="{'background-color':all_app_color}"></div>
          <div class="line"></div>
          <div class="title_top_min_block">
            <div class="title_bottom_line" :style="{'background-color':all_app_color}"></div>
            <i class="iconfont icon-ky_sb title_icon" :style="{'color':all_app_color}"></i>
            <!-- <div class="titletext">{{$t('lang.research_equipment')}}</div>
            <div class="titletextfu">{{$t('lang.research_equipment_zh')}}</div>-->
            <div class="titletext">{{itemlabel.name}}</div>
          </div>
          <div
            v-if="isloginADorGU=='AD'||isloginADorGU=='SAD'"
            v-show="isshowxiugai"
            class="tuxiugai iconfont icon-xiugai"
            @click="goHtIndex('ht_kysb')"
            :style="{'color':all_app_color}"
          ></div>
          <div v-show="!isshowxiugai" class="lookmore lookmore_span_position">
            <span
              :style="{'color':all_app_color}"
              @click="toresearchequipment"
            >{{$t('lang.more')}}>></span>
          </div>
        </div>
        <div class="keyancentent" v-if="index_equipment_list.length!=0">
          <div
            v-if="keyan_screen_show"
            style="width:100%; position:relative;"
            @mouseenter="on_bot_enter_keyan"
            @mouseleave="on_bot_leave_keyan"
          >
            <swiper
              class="swiImgs"
              ref="swiImgs_keyan"
              :options="swiperOption_sbei"
              v-if="index_equipment_list.length>0"
            >
              <swiper-slide
                v-for="(item,index) in index_equipment_list"
                :key="index"
                data-index="index"
                :slidesPerView="4"
                class="keyanlist"
              >
                <div class="keyanlist_position_mubu" @click="shebei_mubu(index)">
                  <div class="keyanlist_position_mubu_content">{{item.content}}</div>
                </div>
                <div class="imgwidth_block_over">
                  <img
                    :preview="index"
                    class="imgwidth"
                    ref="imgwidth"
                    v-if="item.picture&&item.picture.length>=0"
                    :src="item.picture[0]"
                  />
                </div>

                <el-tooltip placement="top">
                  <div slot="content">
                    <div style="max-width:300px; white-space:wrap;text-align:center;">{{item.name}}</div>
                  </div>
                  <p
                    @click="click_new_href(item)"
                    style="cursor:pointer;margin: 15px 10px;text-align: left;"
                  >
                    <span
                      style="display:inline-block;max-width:85%;overflow:hidden; text-overflow:ellipsis; white-space:nowrap;"
                    >{{item.name}}</span>
                    <span
                      style="display: inline-block;vertical-align: text-top;"
                      :style="{'color':all_app_color}"
                    >>></span>
                  </p>
                </el-tooltip>
              </swiper-slide>
            </swiper>
            <div class="swiper-button-next_sbei iconfont icon-zuo"></div>

            <div class="swiper-button-prev_sbei iconfont icon-you"></div>
          </div>
          <div class="keyancentent" v-if="!keyan_screen_show">
            <div class="keyanlist" v-for="(item,index) in index_equipment_list" :key="index">
              <div class="keyanlist_position_mubu" @click="shebei_mubu(index)">
                <div class="keyanlist_position_mubu_content">{{item.content}}</div>
              </div>
              <div class="imgwidth_block_over">
                <img
                  :preview="index"
                  class="imgwidth"
                  ref="imgwidth"
                  v-if="item.picture&&item.picture.length>=0"
                  :src="item.picture[0]"
                />
              </div>
              <el-tooltip placement="top">
                <div slot="content">
                  <div style="max-width:300px; white-space:wrap;text-align:center;">{{item.name}}</div>
                </div>
                <p
                  @click="click_new_href(item)"
                  style="cursor:pointer;margin: 15px 10px;text-align: left;"
                >
                  <span
                    style="display:inline-block;max-width:85%;overflow:hidden; text-overflow:ellipsis; white-space:nowrap;"
                  >{{item.name}}</span>
                  <span
                    style="display: inline-block;vertical-align: text-top;"
                    :style="{'color':all_app_color}"
                  >>></span>
                </p>
              </el-tooltip>
            </div>
          </div>
        </div>
        <div v-else style="margin-top:30px;margin-bottom:30px;text-align: left;margin-right: auto;justify-content: left;" class="keyancentent jianjiecontainer_block ">暂无数据</div>
      </div>
      <div
        class="keyancontainer"
        v-if="itemlabel.is_default=='0'&&
        itemlabel.is_hide==0&&index_custom_list&&index_custom_list[itemlabel.label]&&index_custom_list[itemlabel.label].length"
      >
        <div>
          <div class="zongtitle jianjiecontainer_block">
            <div class="title_hover_line_lang" :style="{'background-color':all_app_color}"></div>
            <div class="line"></div>
            <div class="title_top_min_block">
              <div class="title_bottom_line" :style="{'background-color':all_app_color}"></div>
              <i class="iconfont icon-ky_sb title_icon" :style="{'color':all_app_color}"></i>
              <!-- <div class="titletext">{{$t('lang.research_equipment')}}</div> -->
              <!-- <div class="titletextfu">{{$t('lang.research_equipment_zh')}}</div> -->
              <div class="titletext">{{itemlabel.name}}</div>
            </div>
            <div
              v-if="isloginADorGU=='AD'||isloginADorGU=='SAD'"
              v-show="isshowxiugai"
              class="tuxiugai iconfont icon-xiugai"
              @click="goHtIndex('ht_zdy')"
              :style="{'color':all_app_color}"
            ></div>
           <div v-show="itemlabel.url" class="lookmore lookmore_span_position">
              <span
                :style="{'color':all_app_color}"
                @click="click_new_href_url(itemlabel.url)"
              >{{$t('lang.more')}}>></span>
            </div>
          </div>
          <div class="keyancentent">
            <div
              v-if="keyan_screen_show"
              style="width:100%; position:relative;"
              @mouseenter="on_bot_enter_keyan"
              @mouseleave="on_bot_leave_keyan"
            >
              <swiper
                class="swiImgs"
                ref="swiImgs_keyan"
                :options="swiperOption_sbei"
                v-if="index_custom_list&&index_custom_list[itemlabel.label]&&index_custom_list[itemlabel.label].length>0"
              >
                <swiper-slide
                  v-for="(item,index) in  index_custom_list[itemlabel.label]"
                  :key="index"
                  data-index="index"
                  :slidesPerView="4"
                  class="keyanlist"
                >
                  <!-- <div class="keyanlist_position_mubu" @click="shebei_mubu(index)">
                    <div class="keyanlist_position_mubu_content">{{item.content}}</div>
                  </div>-->
                  <div class="imgwidth_block_over  home_imgwidth_block_over">
                    <img
                      :preview="index"
                      class="imgwidth"
                      ref="imgwidth"
                      v-if="item.pic&&item.pic.length>=0"
                      :src="item.pic[0]"
                    />
                  </div>

                  <el-tooltip placement="top">
                    <div slot="content">
                      <div
                        style="max-width:300px; white-space:wrap;text-align:center;"
                      >{{item.title}}</div>
                    </div>
                    <p
                      @click="click_new_href_url(item.url)"
                      style="cursor:pointer;margin: 15px 10px;text-align: left;"
                    >
                      <span
                        style="display:inline-block;max-width:85%;overflow:hidden; text-overflow:ellipsis; white-space:nowrap;"
                      >{{item.title}}</span>
                      <span
                        v-show="item.url"
                        style="display: inline-block;vertical-align: text-top;"
                        :style="{'color':all_app_color}"
                      >>></span>
                    </p>
                  </el-tooltip>
                </swiper-slide>
              </swiper>
              <div class="swiper-button-next_sbei iconfont icon-zuo"></div>

              <div class="swiper-button-prev_sbei iconfont icon-you"></div>
            </div>
            <div class="keyancentent" v-if="!keyan_screen_show">
              <div
                class="keyanlist"
                v-for="(item,index) in  index_custom_list[itemlabel.label]"
                :key="index"
              >
                <!-- <div class="keyanlist_position_mubu" @click="shebei_mubu(index)">
                  <div class="keyanlist_position_mubu_content">{{item.content}}</div>
                </div>-->
                <div class="imgwidth_block_over ">
                  <img
                    :preview="index"
                    class="imgwidth"
                    ref="imgwidth"
                    v-if="item.pic&&item.pic.length>=0"
                    :src="item.pic[0]"
                  />
                </div>
                <el-tooltip placement="top">
                  <div slot="content">
                    <div style="max-width:300px; white-space:wrap;text-align:center;">{{item.title}}</div>
                  </div>
                  <p
                    @click="click_new_href_url(item.url)"
                    style="cursor:pointer;margin: 15px 10px;text-align: left;"
                  >
                    <span
                      style="display:inline-block;max-width:85%;overflow:hidden; text-overflow:ellipsis; white-space:nowrap;"
                    >{{item.title}}</span>
                    <span
                      v-show="item.url"
                      style="display: inline-block;vertical-align: text-top;"
                      :style="{'color':all_app_color}"
                    >>></span>
                  </p>
                </el-tooltip>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-show="false">{{all_app_color_comp}}</div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
require("swiper/dist/css/swiper.css");
// import { Loading } from "element-ui";
import * as serviceApi from "./api/homeTemplateTwo";
export default {
  name: "homeTemplateTwo",
  data() {
    return {
      index_custom_list: {}, //
      all_app_color: "#3b9dce",
      keyan_screen_show: true,
      swiperOption: {
        grabCursor: true, //鼠标覆盖Swiper时指针会变成手掌形状，拖动时指针会变成抓手形状
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
        // 参数选项,显示小点
        // pagination: ".swiper-pagination",
        //循环
        loop: true,
        //每张播放时长3秒，自动播放
        autoplay: true,
        interval: 3000,
        //滑动速度
        speed: 1000,
        // delay:1000
        slidesPerView: 4,
        spaceBetween: 30,
        slidesPerGroup: 4,
        // loop: true,
        loopFillGroupWithBlank: true,
        // pagination: {
        //   el: ".swiper-pagination",
        //   clickable: true
        // },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        stopOnLastSlide: false
      },
      swiperOption_sbei: {
        grabCursor: true, //鼠标覆盖Swiper时指针会变成手掌形状，拖动时指针会变成抓手形状
        // slidesPerColumn: 2,
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
        // 参数选项,显示小点
        // pagination: ".swiper-pagination",
        //循环
        loop: false,
        //每张播放时长3秒，自动播放
        autoplay: true,
        interval: 31000,
        reverseDirection: true, //开启反向自动轮播。
        // stopOnLastSlide: true, //如果设置为true，当切换到最后一个slide时停止自动切换。
        //滑动速度
        speed: 5000,
        // delay:1000
        slidesPerView: 4,
        spaceBetween: 50,
        // slidesPerGroup: 4,
        // loop: true,
        loopFillGroupWithBlank: true,
        // pagination: {
        //   el: ".swiper-pagination",
        //   clickable: true
        // },
        // navigation: {
        //   nextEl: ".swiper-button-next",
        //   prevEl: ".swiper-button-prev"
        // },
        navigation: {
          nextEl: ".swiper-button-next_sbei", //前进按钮的css选择器或HTML元素。
          prevEl: ".swiper-button-prev_sbei" //后退按钮的css选择器或HTML元素。
          // hideOnClick: true, //点击slide时显示/隐藏按钮
          // disabledClass: "my-button-disabled", //前进后退按钮不可用时的类名。
          // hiddenClass: "my-button-hidden" //按钮隐藏时的Class
        },
        stopOnLastSlide: false
      },
      // is_min_pingmu:false,
      xinwenzhongjian_no_content: true,
      zunei_no_content: true,
      loading: true,
      index_research_results_list: "",
      index_member_list: "",
      index_equipment_list: "", //科研设备
      xinwen: "",
      xinwenzhongjian: "",
      zunei: "", //组内成员
      zuneititle: "",
      xinwenzhongjiantitle: "",
      xinwentitle: "",
      introduction_research_areas: "",
      introduction_research_areas_KTZFZR: "",

      // dynamiclist:[]    //存放动态的筛选种类
      layout_page_managementlist: [
        {
          is_hide: 0
        },
        {
          is_hide: 0
        },
        {
          is_hide: 0
        },
        {
          is_hide: 0
        },
        {
          is_hide: 0
        },
        {
          is_hide: 0
        }
      ], //获取显示隐藏标签

      home_nav_list_is_hide_on_topath: {      //导航菜单隐藏的情况下，点击首页更多，判断是否跳转
      have_value:false,
      ktzjs:false,
      yjfx:false,
      cgzs:false,
      dt:false,
      kysb:false,
      cygl:false,
      principalIntroduce:false,
      fzrjs:false
    },

      liangzhong_dt: true, //动态数据的类型种类数
      yizhong_dt: true,
      sanzhong_dt: true,

      interval_time: "", //计时器
      countDownTime: 0
      // is_sessionStorage:false
    };
  },
  computed: {
    all_app_color_comp() {
      if (this.$store.state.all_app_color) {
        this.all_app_color = this.$store.state.all_app_color; //将本地的全局配色，赋值给 this.all_app_color
      }
      return "";
    },
    chengguocentent_background_list() {
      return function(index) {
        return index % 6;
      };
      return this.getRandom(0, 5);
      //5-20之间的随机数，包括5和20
    },
    //监听是否点击了编辑的按钮
    isshowxiugai() {
      return this.$store.state.isshowxiugai;
    },
    //监听判断是否已经登录
    isloginADorGU() {
      return this.$store.state.role;
    }
  },
  beforeRouteLeave(to, from, next) {
    // 导航离开该组件的对应路由时调用
    // 可以访问组件实例 `this`
    clearInterval(this.interval_time);
    // this.interval_time = "";
    window.sessionStorage.removeItem("countDownTime");
    // window.sessionStorage.removeItem("interval_time");
    // sessionStorage.setItem("interval_time", this.interval_time);
    sessionStorage.setItem("countDownTime", this.countDownTime);
    next();
  },
  //挂载监听函数
  destroyed() {
    window.removeEventListener(
      "beforeunload",
      this.updateHandler_is_sessionStorage
    );
  },
  created() {
    if (this.$store.state.all_app_color) {
      this.all_app_color = this.$store.state.all_app_color;
    } else {
      this.all_app_color = localStorage.getItem("all_app_color"); //将本地的全局配色，赋值给 this.all_app_color
    }

    this.swiperOption.autoplay =
      this.index_equipment_list.length != 1
        ? {
            disableOnInteraction: false, // 用户操作swiper之后，是否禁止autoplay
            delay: 3000 // 自动切换的时间间隔（单位ms）
          }
        : false;
    this.swiperOption_sbei.autoplay =
      this.index_research_results_list.length != 1
        ? {
            disableOnInteraction: false, // 用户操作swiper之后，是否禁止autoplay
            delay: 3000 // 自动切换的时间间隔（单位ms）
          }
        : false;
    if (document.body.clientWidth < 1200) {
      // this.keyan_screen_show = false;
      // this.swiperOption_sbei.autoplay = false;
    }
    if (document.body.clientWidth < 992) {
      //成果轮播图
      // this.keyan_screen_show=false;
      this.swiperOption.slidesPerView = 2;
      this.swiperOption.slidesPerGroup = 2;
      this.swiperOption_sbei.slidesPerView = 3;
      this.swiperOption_sbei.slidesPerGroup = 3;
      // spaceBetween: 30
      // this.swiperOption_sbei.autoplay = false;
      this.swiperOption.autoplay = true;
    }
    if (document.body.clientWidth < 480) {
      this.swiperOption.slidesPerView = 1;
      this.swiperOption.slidesPerGroup = 1;

      this.swiperOption_sbei.slidesPerView = 2;
      this.swiperOption_sbei.slidesPerGroup = 2;
      // this.swiperOption.spaceBetween = '';
      // this.swiperOption_sbei.autoplay = false;
      this.swiperOption.autoplay = true;
      // this.keyan_screen_show = false;
    }
    window.addEventListener(
      "beforeunload",
      this.updateHandler_is_sessionStorage
    );
    // sessionStorage.setItem("head", body.data.head);
    if (sessionStorage.getItem("countDownTime")) {
      this.countDownTime = sessionStorage.getItem("countDownTime");
      // this.interval_time = sessionStorage.getItem("interval_time");
    }

    window.scrollTo(0, 0); // 置顶代码
    this.layout_page_management(); //获取显示隐藏标签
    this.getalldata(); //请求页面主要内容数据列表
    this.home_nav_list_is_hide_on_topath = this.$store.state.home_nav_list_is_hide_on_topath;
    // this.getchushihuaDataList();
  },
  filters: {
    //html剔除富文本标签，留下纯文本
    deletehtmltext(html) {
      if (!html) {
        return "";
      }
      var re1 = new RegExp("<.+?>", "g"); //匹配html标签的正则表达式，"g"是搜索匹配多个符合的内容
      var msg = html.replace(re1, ""); //执行替换成空字符
      var str = msg;
      if (msg.length > 202) {
        str = str.substr(0, 202) + "...";
      }

      return str;
    }
  },
  components: {
    swiper,
    swiperSlide
  },
  methods: {
    click_new_href_url(url) {
      //打开新的链接   快速入口用到了

      if (url) {
        let aa = this.GLOBAL.BASE_XUEHUI_URL;
        let reg = RegExp(aa);

        if (reg.test(url)) {
          let router = url.split("/#")[1];

          // this.$store.commit("change_home_more_click", true);
          // this.$router.push({ path: router });
          if (router) {
            // this.$store.commit("change_home_more_click", true);
            // this.$router.push({ path: router });
            this.RequestgetnavDataList(router, url);
          } else {
            window.open(url);
          }
        } else {
          window.open(url);
        }

        // if (url) {
        //   window.open(url);
        // }
      }

      // console.log("111");
    },
    //获取导航栏菜单列表
    RequestgetnavDataList(aaa, url) {
      let that = this;
      let allnavlist = [];
      let navlist = "";
      // this.navlist = [];
      serviceApi.getnavDataList({}).then(body => {
        allnavlist = body.data;
        navlist = allnavlist.filter(function(item) {
          return item.is_hide == 0;
        });
        navlist.splice(0, 0, {
          //整个导航的信息
          menu_id: "000",
          menu_name: "首页",
          english_name: "HOME",
          routes: "/home"
        });
        let arr = navlist;

        for (let j = 0; j < arr.length; j++) {
          // console.log(arr[j].routes == aaa);
          if (arr[j].routes == aaa) {
            this.$store.commit("change_home_more_click", true);
            this.$router.push({ path: aaa });
            return;
          } else {
            
              // console.log('0000');
              window.open(url);
            
          }
        }
      });
    },
    // click_new_href_url(url) {
    //   //打开新的链接   快速入口用到了

    //   if (url) {
    //     let aa = this.GLOBAL.BASE_XUEHUI_URL;
    //     let reg = RegExp(aa);

    //     if (reg.test(url)) {
    //       let router = url.split("/#")[1];

    //       // this.$store.commit("change_home_more_click", true);
    //       // this.$router.push({ path: router });
    //       if (router) {
    //         this.$store.commit("change_home_more_click", true);
    //         this.$router.push({ path: router });
    //       } else {
    //         window.open(url);
    //       }
    //     } else {
    //       window.open(url);
    //     }

    //     // if (url) {
    //     //   window.open(url);
    //     // }
    //   }

    //   // console.log("111");
    // },
    click_new_href(data) {
      this.$router.push({
        path: "/equipmentdetails",
        query: {
          data: data
        }
      });
    },
    shebei_mubu(index) {
      let name = this.$refs.imgwidth[index].click();

      // this.$refs.name.click();
    },
    //获取随机数
    // getRandom(x,y){
    //     //x 下限
    //  	    //y 上限
    //     return parseInt(Math.random() * (y - x + 1) + x) ;
    // },
    stopPlay() {
      this.$refs.swiImgs[0].swiper.autoplay.stop(); // 当手指触摸时停止自动播放
    },
    play() {
      this.$refs.swiImgs[0].swiper.autoplay.start(); // 当手指离开时开始自动播放
    },
    //通过获得的swiper对象来暂停自动播放
    on_bot_enter_keyan() {
      this.$refs.swiImgs_keyan[0].swiper.autoplay.stop();
    },
    on_bot_leave_keyan() {
      // this.$refs.swiImgs.swiper.autoplay.stop();
      this.$refs.swiImgs_keyan[0].swiper.autoplay.start();
    },
    //通过获得的swiper对象来暂停自动播放
    on_bot_enter() {
      this.$refs.swiImgs[0].swiper.autoplay.stop();
    },
    on_bot_leave() {
      // this.$refs.swiImgs.swiper.autoplay.stop();
      this.$refs.swiImgs[0].swiper.autoplay.start();
    },
    //页面刷新前
    updateHandler_is_sessionStorage() {
      clearInterval(this.interval_time);
      // that.interval_time = "";
      window.sessionStorage.removeItem("countDownTime");
      // window.sessionStorage.removeItem("is_sessionStorage");
      // window.sessionStorage.removeItem("interval_time");
      // sessionStorage.setItem("interval_time", this.interval_time);
      sessionStorage.setItem("countDownTime", this.countDownTime);
      // sessionStorage.setItem("is_sessionStorage", true);
    },
    // //loading效果
    // startLoading: function() {
    //   loading = Loading.service({
    //     lock: true,
    //     text: "加载中……",
    //     background: "rgba(255, 255, 255, 0.8)"
    //   });
    // },
    // //loading效果
    // endLoading: function() {
    //   loading.close();
    // },
    //     getchushihuaDataList(){
    // let that = this;
    //       serviceApi.getchushihuaDataList({}).then(body => {
    //         that.dynamiclist = body.data;
    //       });
    //     },
    //获取显示隐藏标签
    layout_page_management() {
      let that = this;
      serviceApi
        .layout_page_management({
          type: "portal_home_management_2"
        })
        .then(body => {
          // that.layout_page_managementlist = body.data;
          that.layout_page_managementlist = [];
          for (let i = 0; i < body.data.length; i++) {
            if (body.data[i].label != "YJLY00000") {
              that.layout_page_managementlist.push(body.data[i]);
            }
          }
        });
    },
    //获取数据之后调用一次
    add_access() {
      window.sessionStorage.removeItem("countDownTime");
      this.countDownTime = 20;
      let that = this;
      serviceApi.add_access({}).then(body => {});
    },
    //跳往后台
    goHtIndex(anchor) {
      window.open(this.GLOBAL.HT_INDEX_CONFIG_ + `?anchor=${anchor}`);
    },
    //请求页面主要内容数据列表
    getalldata() {
      // this.loading=true;
      let that = this;
      serviceApi
        .getDataList({
          type: "portal_home_management_2"
        })
        .then(body => {
          if (this.countDownTime == 0) {
            that.add_access();
          } else {
            // if(!that.interval_time){
            this.interval_time = setInterval(() => {
              if (that.countDownTime != 0) {
                that.countDownTime -= 1;
              } else {
                clearInterval(that.interval_time);
                // that.interval_time = "";
                // window.sessionStorage.removeItem("interval_time");
              }
            }, 1000);
            // }
          }
          that.index_member_list = body.data.index_member;
          that.introduction_research_areas_KTZFZR = body.data.index_principal;
          that.index_equipment_list = body.data.index_equipment;
          that.introduction_research_areas = body.data.index_introduction;
          that.index_research_results_list = body.data.index_results; //成果展示
          if (body.data.index_news) {
            if (body.data.index_news.length == 1) {
              // that.yizhong_dt=false;
              that.xinwentitle = body.data.index_news[0].title;
              that.xinwen = body.data.index_news[0].data;
              if (that.xinwen.length > 3 && that.xinwen.length < 7) {
                let arr = that.xinwen.slice(3);
                that.xinwenzhongjian = arr;
                that.xinwenzhongjiantitle = "";
                that.liangzhong_dt = false;
                that.sanzhong_dt = false;
                that.zunei = "";
                // that.zunei = body.data.index_news[1].data;
                // that.zuneititle = body.data.index_news[1].title;
              } else if (that.xinwen.length > 6) {
                let arr = that.xinwen.slice(3, 6);
                that.xinwenzhongjian = arr;
                that.xinwenzhongjiantitle = "";
                let arrarr = that.xinwen.slice(6);
                that.zunei = arr;
                that.zuneititle = "";
                that.liangzhong_dt = false;
                that.yizhong_dt = false;
              } else {
                that.yizhong_dt = false;
                that.sanzhong_dt = false;
              }
            } else if (body.data.index_news.length == 2) {
              that.xinwen = body.data.index_news[0].data;
              that.xinwentitle = body.data.index_news[0].title;
              if (that.xinwen.length > 3) {
                let arr = that.xinwen.slice(3);
                that.xinwenzhongjian = arr;
                that.xinwenzhongjiantitle = "";
                that.liangzhong_dt = false;
                that.zunei = body.data.index_news[1].data;
                that.zuneititle = body.data.index_news[1].title;
              } else {
                that.xinwenzhongjian = body.data.index_news[1].data;
                that.xinwenzhongjiantitle = body.data.index_news[1].title;
              }
            } else if (body.data.index_news.length == 3) {
              that.xinwen = body.data.index_news[0].data;
              that.xinwentitle = body.data.index_news[0].title;
              that.xinwenzhongjian = body.data.index_news[1].data;
              that.xinwenzhongjiantitle = body.data.index_news[1].title;
              that.zunei = body.data.index_news[2].data;
              that.zuneititle = body.data.index_news[2].title;
            }
          }

          let arrALLdata = body.data;
          // for (let i = 0; i < arrALLdata.length; i++) {
          //   if(arrALLdata[i]){

          //   }
          //
          // }
          that.index_custom_list = {};
          for (let key in arrALLdata) {
            // console.log(key);
            if (
              key != "index_carousel" &&
              key != "index_research_progress" &&
              key != "index_introduction" &&
              key != "index_news" &&
              key != "index_member" &&
              key != "index_results"
            ) {
              // console.log(arrALLdata[key]);
              let name = key.split("index_custom_module_")[1];
              if (name) {
                that.index_custom_list[name] = arrALLdata[key];
              }
            }
          }
          // console.log(that.index_custom_list);
          this.loading = false;
        });
    },
    //跳往研究方向页面
    toresearchdirection() {
      // if (this.home_nav_list_is_hide_on_topath.yjfx) {
        this.$store.commit("change_home_more_click", true); //判断是否是首页点击了查看更多的事件
        this.$router.push({ path: "/researchdirection" });
      // }
    },
    //跳往页面
    toprincipalIntroduce() {
      // if (this.home_nav_list_is_hide_on_topath.principalIntroduce) {
        this.$store.commit("change_home_more_click", true); //判断是否是首页点击了查看更多的事件
        this.$router.push({ path: "/principalIntroduce" });
      // }
    },
    //跳往课题组介绍页面
    toktzintroduce() {
      // console.log(this.home_nav_list_is_hide_on_topath.ktzjs);
      // if (this.home_nav_list_is_hide_on_topath.ktzjs) {
        this.$store.commit("change_home_more_click", true); //判断是否是首页点击了查看更多的事件
        this.$router.push({ path: "/ktzintroduce" });
      // }
    },
    //跳往研究进展详情页
    toyanjiujinzhanxiangqingye(id, type) {
      let index = "";

      if (type == "RYLB00000") {
        index = 0;
      } else if (type == "LWLB00000") {
        index = 1;
      } else if (type == "ZZLB00000") {
        index = 2;
      } else if (type == "ZLLB00000") {
        index = 3;
      } else if (type == "RJZZ00000") {
        index = 4;
      }
      // if (this.home_nav_list_is_hide_on_topath.cgzs) {
        this.$store.commit("change_home_more_click", true);
        this.$router.push({
          path: "/researchProgressDetails",
          query: { id: id, index: index }
        });
      // }
    },
    //跳往研究进展
    toresearchprogress() {
      // if (this.home_nav_list_is_hide_on_topath.cgzs) {
        this.$store.commit("change_home_more_click", true);
        this.$router.push({ path: "/researchprogress" });
      // }
    },
    //跳往动态详情
    todynamicDetails(id) {
      // if (this.home_nav_list_is_hide_on_topath.dt) {
        this.$store.commit("change_home_more_click", true);
        this.$router.push({ path: "/dynamicDetails", query: { id: id } });
      // }
    },
    //跳往动态
    todynamic_inti() {
      // if (this.home_nav_list_is_hide_on_topath.dt) {
        this.$store.commit("change_home_more_click", true);
        this.$router.push({ path: "/dynamic" });
      // }
    },
    //跳往动态
    todynamic(name) {
      // if (this.home_nav_list_is_hide_on_topath.dt) {
        this.$store.commit("change_home_more_click", true);
        this.$router.push({ path: "/dynamic", query: { name: name } });
      // }
    },
    //跳往个人主页
    tomember(id, link_suffix) {
      // let obj = {};
      // obj.id=id;
      // obj.old_path='/home';
      // let myJSON = JSON.stringify(obj);
      // let myJSON = `${myJSON}`;

      // this.$store.commit('change_home_more_click',true);
      let str = "";
      if (link_suffix) {
        str = "member/" + link_suffix;
      } else {
        let json_data = id + "." + "home";
        str = "member/" + json_data;
      }

      let routeData = this.$router.resolve({ name: str });
      window.open(routeData.href + str, "_blank");
    },
    //跳往科研设备
    toresearchequipment() {
      // if (this.home_nav_list_is_hide_on_topath.kysb) {
        this.$store.commit("change_home_more_click", true);
        this.$router.push({ path: "/researchequipment" });
      // }
    },
    //跳往团队介绍
    toteamintroduction() {
      //       console.log('toteamintroduction');
      // console.log('this.home_nav_list_is_hide_on_topath.cygl',this.home_nav_list_is_hide_on_topath.cygl);
      // if (this.home_nav_list_is_hide_on_topath.cygl) {
        this.$store.commit("change_home_more_click", true);
        this.$router.push({ path: "/teamintroduction" });
      // }
    }
  },
  mounted() {
    //  if (document.body.clientWidth < 1200) {
    // //   this.clientWidthmub = 10;
    // }
    if (document.body.clientWidth < 992) {
      // this.collapseChage();
      this.xinwenzhongjian_no_content = false;
      this.zunei_no_content = false;
    }
  }
};
</script>
<style>
.imgwidth .el-image__inner {
  width: 100%;
  /* height: auto !important; */
}
</style>
<style scoped>

/* .LWsource{
      max-width: calc(100% - 100px);
    overflow: hidden;
    display: inline-block;
    word-break: keep-all;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

} */
.LWsource_div{
      /* max-width: calc(100% ); */
      text-align: right;
      width: 100%;
    overflow: hidden;
    display: inline-block;
    /* word-break: keep-all; */
        word-break: break-all;
     overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;

}
.chengguocentent_mubu_text_time {
  font-size: 14px;
  color: #ffffff;
  display: flex;
  margin-top: 5px;
  /* padding-right: 40px; */
  justify-content: flex-end;
}
.LWsource{
      max-width: calc(100% );
    overflow: hidden;
    display: inline-block;
  word-break: break-all;
     overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;

}
.home_img_ZDY .home_imgwidth_block_over{
  height: auto;
}
.home_img_ZDY .home_imgwidth_block_over .imgwidth{
  height: auto;
}



/* .JD_seven{
    overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 7;
  -webkit-box-orient: vertical;
} */
.img_width_height {
  width: 150px;
  height: 150px;
  margin-right: 20px;
  float: left;
  margin-top: -10px;
      border-radius: 5px;
}
.name_font {
  font-size: 18px;
}
.FZRJS_font {
  font-size: 18px;
  line-height: 28px;
  letter-spacing: 1px;
}
.maxscreenblock {
  display: block;
}
.minscreenblock {
  display: none;
}
/* .keyancentent .swiper-container {
width: 100%;
height: 100%;
margin-left: auto;
margin-right: auto;
} */
.chengguocentent_wai_block_pois_rela .swiper-button-next,
.chengguocentent_wai_block_pois_rela .swiper-button-prev {
  background-image: none;
  background-color: rgba(31, 45, 61, 0.21);
  width: 58px;
  height: 58px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ffffff;
}
.keyancentent .swiper-button-next_sbei,
.keyancentent .swiper-button-prev_sbei {
  background-image: none;
  background-color: rgba(31, 45, 61, 0.21);
  width: 58px;
  height: 58px;
  border-radius: 50%;
  border-color: none;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ffffff;
  /* display: none; */
  opacity: 0;
  transition: all 0.3s linear;
  /* transform: scale(0.6); */
}
.keyancentent .swiper-button-next_sbei {
  right: 10px;
  left: auto;
}
.keyancentent .swiper-button-prev_sbei {
  left: 10px;
  right: auto;
}
.keyancentent .swiper-button-prev_sbei,
.keyancentent .swiper-button-next_sbei {
  position: absolute;
  top: 50%;
  width: 34px;
  height: 34px;
  margin-top: -22px;
  z-index: 10;
  font-size: 14px;
  cursor: pointer;
  background-size: 27px 44px;
  background-position: center;
  background-repeat: no-repeat;
}
.keyancentent:hover .swiper-button-prev_sbei,
.keyancentent:hover .swiper-button-next_sbei {
  opacity: 1;
}
.keyancontainer:hover .title_hover_line_lang,
.chengguocontainer:hover .title_hover_line_lang,
.chengyuancontainer:hover .title_hover_line_lang,
.lingyucontainer:hover .title_hover_line_lang,
.dongtaicontainer:hover .title_hover_line_lang,
.jianjiecontainer:hover .title_hover_line_lang {
  width: 100%;
}
.title_hover_line_lang {
  width: 0px;
  height: 2px;
  position: absolute;
  bottom: -3px;
  left: 0px;
  background-color: #3b9dce;
  transition: all 1s linear;
}
.xinwenzhongjianbottom_hover {
  cursor: pointer;
  padding: 5px;
  margin: 5px 0;
  position: relative;
  transition: all 0.2s linear;
}
.xinwenzhongjianbottom_hover:hover {
  overflow: hidden;
  transform: translateY(-2px);

  /* box-shadow: rgba(0, 0, 0, 0.1) 1px 2px 3px 2px; */
}
.jianjiecontainer_block {
  position: relative;
}
.dt_position_line {
  width: 100px;
  height: 1px;
  background-color: #d4d3d3;
  position: absolute;
  left: 0px;
  bottom: 0px;
  display: none;
}
.huixinzheng_cg_position {
  position: absolute;
  top: -14px;
  right: 0px;
  font-size: 28px;
  transform: rotateY(10deg);
  /* display: none; */
  z-index: 20;
  color: #3b9dce;
  opacity: 0;
  transition: all 0.3s linear;
}
.title_icon {
  font-size: 26px;
  margin-right: 8px;
  color: #3b9dce;
}
.lookmore_span_position {
  position: absolute;
  right: 10px;
  top: 0px;
}
.chengguocentent_wai_block_pois_rela {
  position: relative;
  margin-bottom: 40px;
}
.chengguocentent_wai_block_pois_rela:hover .huixinzheng_cg_position {
  /* display: block; */
  opacity: 1;
}
.chengguocentent_wai_block_pois_rela .swiper-button-next,
.chengguocentent_wai_block_pois_rela .swiper-button-prev {
  opacity: 0;
  transition: all 0.3s linear;
  transform: scale(0.6);
}
/* .swiper-button_yuan{
  position: absolute;
  top: 0px;
  left: 0px;
  background-color: #99999966;
  z-index: 1;
} */
.chengguocentent_wai_block_pois_rela:hover .swiper-button-next,
.chengguocentent_wai_block_pois_rela:hover .swiper-button-prev {
  opacity: 1;
}
.chengguocentent_mubu {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
border-radius: 5px;
  background-repeat: no-repeat;
  background-position: center;
  background: round;
  /* z-index: 10; */
  /* overflow: hidden;
  background-color: #f3f3f3; */
}
.chengguocentent {
  width: 370px;
  height: 400px;
  /* background-image: url("../../../assets/cg_bj.jpg"); */
  display: inline-block;
  margin-right: 25px;
  margin-top: 30px;
  cursor: pointer;
  box-shadow: rgba(0, 0, 0, 0.07) 0px 3px 4px 2px;
  /* background-attachment: fixed; */
  /* filter: blur(4px); */
}
.chengguocentent_mubu0::before {
  background-image: url("../../../assets/cg_bj.jpg");
}
.chengguocentent_mubu1::before {
  background-image: url("../../../assets/cg_bj1.jpg");
}
.chengguocentent_mubu2::before {
  background-image: url("../../../assets/cg_bj2.jpg");
}
.chengguocentent_mubu3::before {
  background-image: url("../../../assets/cg_bj3.jpg");
}
.chengguocentent_mubu4::before {
  background-image: url("../../../assets/cg_bj4.jpg");
}
.chengguocentent_mubu5::before {
  background-image: url("../../../assets/cg_bj5.jpg");
}
.chengguocentent_mubu::before {
  content: "";
  /* width: 100%;
  height: 100%; */
  position: absolute;
  background-image: inherit;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  /* background-attachment: local; */
  /* background-repeat: round; */

  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;

  /* background-image: var(--url(chengguocentent_background_list+)); */
  /* background-image: url("../../../assets/cg_bj.jpg"); */
  /* background: #fff; */
  /* background-attachment: fixed; */
  filter: blur(12px);
}
.chengguocentent_mubu::after {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(6, 6, 6, 0.23);
}
.title_top_min_block {
  display: inline-block;
  padding: 0 0px;
  position: relative;
  background-color: #fff;
  height: 35px;
  position: relative;
}
.keyanlist:hover {
  overflow: hidden;
  transform: translateY(-5px);

  /* transform: scale(1.05); */
  box-shadow: rgba(0, 0, 0, 0.17) 0px 3px 4px 2px;
}
.keyanlist:hover .imgwidth_block_over .imgwidth {
  transform: translateY(-10px);

  transform: scale(1.05);
}
.keyanlist_position_mubu:hover .keyanlist_position_mubu_content {
  display: block;
}
.keyanlist_position_mubu:hover {
  display: block;

  background-color: #33333377;
}
.imgwidth_block_over {
  overflow: hidden;
  border-radius: 5px;
  width: 255px;
  height: 250px;
  margin: 5px;
}
.keyanlist_position_mubu_content {
  width: 80%;
  height: 80%;
  padding: 10%;
  padding-top: 10%;
  word-break: break-all;
  position: absolute;
  left: 0px;
  top: 0px;
  text-indent: 2em;
  color: #ffffff;
  font-size: 15px;
  line-height: 20px;
  display: none;
}
.keyanlist_position_mubu {
  /* width: 100%; */
  /* height: 77%; */
  /* height: 260px; */
  background-color: #33333300;
  position: absolute;
  top: 0px;
  left: 0px;
  z-index: 10;
  width: 255px;
  height: 250px;
  margin: 5px;
  transition: all 0.5s linear;
  overflow: hidden;
}
.title_bottom_line {
  width: 100%;
  height: 2px;
  position: absolute;
  bottom: -3px;
  left: 0px;
  background-color: #3b9dce;
}
.title_bottom_line_hui {
  width: 100%;
  height: 1px;
  position: absolute;
  bottom: -2px;
  left: 0px;
  background-color: #aaaaaa;
}
.chengyuanlist_container {
  margin: 10px 0;
  text-align: center;
  font-size: 18px;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.chengguotopcontainer {
  font-size: 18px;
  /* height: 40px; */
  line-height: 26px;
  width: 100%;
  word-break: break-all;
  text-indent: 2em;
  display: inline-block;
  color: #ffffff;
  font-weight: 600;
  /* overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical; */
}
.chengguocentent_mubu_rongyu_label {
  position: absolute;
  top: 23px;
  left: 18px;
  color: #ffffff;
  z-index: 9;
}

.chengyuanlist img {
  width: 130px;
  height: 130px;
  border-radius: 50%;
  transition: all 0.8s linear;
}
.imgwidth {
  width: 250px;
  height: 250px;
  margin: 5px 0;
  border-radius: 5px;
  /* width: 100%; */
  padding: 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  /* height: 150px; */
  overflow: hidden;
  transition: all 0.5s linear;
    object-fit: cover;
  object-position: center;
}

.lookmore span {
  margin-left: 50px;
}
.huicolortext {
  font-size: 14px;
  color: #888888;
  margin: 10px 0;
  text-align: center;
}
.chengyuanlist {
  cursor: pointer;
  width: 150px;
  text-align: center;
  margin: 15px 25px 25px 25px;
  padding-top: 10px;
  transition: all 0.3s linear;
}
.chengyuanlist:hover {
  overflow: hidden;
  transform: translateY(-2px);
  box-shadow: rgba(0, 0, 0, 0.1) 1px 2px 3px 2px;
}
/* .chengyuanlist:hover .chengyuanlist_img_hover_hidden img {
  transform: scale(1.05);

  border-radius: 5px;
} */
/* .chengyuanlist:hover .chengyuanlist_img_hover_hidden {
  border-radius: 5px;
} */
.chengyuanlist_img_hover_hidden {
  width: 100%;
  width: 100%;
  border-radius: 50%;
  overflow: hidden;
  transition: all 0.6s linear;
}
.chengyuancontainer {
  width: 1200px;
  margin: 0 auto;
  margin-top: 50px;
  margin-bottom: 40px;
}
.chengyuancentent {
  display: flex;
  flex-wrap: wrap;
}
/* 科研 */
.keyanlist {
  cursor: pointer;
  width: 265px;
  margin: 40px 30px 10px 0;
  position: relative;
  transition: all 0.5s linear;
  /* box-shadow: rgba(0, 0, 0, 0.07) 0px 1px 4px 2px; */
}
.keyancentent {
  display: flex;
  flex-wrap: wrap;
  /* margin-bottom: 60px; */
}
.keyancontainer {
  width: 1200px;
  margin: 0 auto;
  margin-top: 50px;
}

/* dongtai */
.twop {
  font-size: 14px;
  color: #888888;
  padding-bottom: 3px;
}
.onep {
  font-size: 18px;
  margin-bottom: 10px;
  line-height: 25px;
  word-break: break-all;
}
.chengguotopcontainer:hover,
.onep:hover {
  color: var(--color);
}
.zuneititle,
.xinwentitle {
  font-weight: 600;
  font-size: 20px;
  margin: 15px 0px;
}
.linewor {
  width: 3px;
  height: 16px;
  background: #3b9dce;
  margin-right: 10px;
}

.xinwentop,
.zuneitop {
  display: flex;
  align-items: center;
  height: 50px;
}
.zunei,
.xinwenzhongjian,
.xinwenzhongjiantop,
.zuneitop,
.zuneitopzhong {
  width: 370px;
}
.xinwenzhongjian,
.xinwenzhongjiantop,
.zunei {
  margin-left: 45px;
}
.xinwen {
  width: 370px;
}
.xinwencontainer {
  display: flex;
}
.dongtaicontainer {
  width: 1200px;
  margin: 0 auto;
  margin-top: 50px;
}

.chengguobottom {
  font-size: 15px;
  color: #ffffff;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  margin-top: 5px;
  /* padding-right: 40px; */
  -webkit-box-pack: end;
  -ms-flex-pack: end;
  justify-content: flex-end;
  margin-bottom: 15px;
  line-height: 22px;
  max-height: 90px;
  overflow: hidden;
}
.chengguocentent_mubu_text_time {
  font-size: 14px;
  color: #ffffff;
  display: flex;
  margin-top: 5px;
  /* padding-right: 40px; */
  justify-content: flex-end;
}
.chengguotop {
  height: initial;
  margin-bottom: 20px;
  margin-top: 55px;
  overflow: hidden;
  min-height: 150px;
  /* padding-right: 25px; */
  position: relative;
}
.righttext {
  height: 80%;
  width: 80%;
  padding: 10%;
  position: relative;
  z-index: 9;
}
.chengguoimg {
  width: 136px;
  height: 100px;
  margin-right: 10px;
}

.tuxiugai {
  position: absolute;
  right: 0px;
  top: 0px;
  margin: 0 15px;
  width: 30px;
  height: 30px;
  font-weight: 600;
  /* color: #9da5a7; */
  cursor: pointer;
}

.line {
  /* width: 200px;
  height: 2px;
  background: #cccccc;
  margin: 0 25px; */
  height: 1px;
  background-color: #d3d3d3;
  position: absolute;
  /* left: 50px; */
  /* right: 50px; */
  bottom: -2px;
  width: 100%;
}
.titletextfu {
  /* color: #cccccc;
  font-size: 20px;
  margin-left: 10px; */
  color: #cccccc;
  font-size: 20px;
  margin-left: 10px;
  text-align: center;
  display: inline-block;
}
.titletext {
  display: inline-block;
  font-size: 25px;
  font-weight: 600;
}
.zongtitle {
  /* display: flex;
  width: 1200px;
  justify-content: center;
  align-items: center;
  position: relative;
  margin: 30px 0; */
  margin: 30px 0;
  height: 35px;
  margin-bottom: 15px;
  position: relative;
  /* text-align: center; */
}
.chengguocontainer {
  width: 1200px;
  margin: 0 auto;
  margin-top: 50px;

  /* display: flex; */
}
.oneblock {
  width: 1200px;
  margin: 0 auto;
}
.lookmore {
  color: #3b9dce;
  margin-top: 10px;
  font-size: 14px;
  cursor: pointer;
  display: flex;
}
.textcontent {
  width: 95%;
  font-size: 14px;
  line-height: 18px;
}
.textcontent p {
  font-size: 18px;
  line-height: 28px;
  text-indent: 2em;
  letter-spacing: 1px;
}
.xiugai {
  width: 30px;
  height: 30px;
  font-weight: 600;
  /* color: #9da5a7; */
  cursor: pointer;
  /* margin-left: auto; */
  position: absolute;
  right: 10px;
}
.titletop .titlefu {
  color: #cccccc;
  font-size: 20px;
  margin-left: 10px;
  display: none;
}
.titletop .title {
  font-size: 25px;
  font-weight: 600;
}
.titletop {
  display: flex;
  margin-top: 30px;
  margin-bottom: 15px;
  align-items: baseline;
  height: 35px;
  width: fit-content;
  position: relative;
}

.jianjiecontainer {
  width: 450px;
}
.lingyucontainer {
  width: 650px;
  margin-right: auto;
}
.container {
  padding: 0px;
  background: #ffffff;
  border: none;
  border-radius: 0px;
  min-height: 650px;
}
.chengguomore {
  margin-right: 5px;
}
.xinwenzhongjianbottom {
  width: 400px;
}

.oneblock {
  display: flex;
  margin-top: 10px;
}
.lookmore span {
  margin-left: 0px;
  color: #3b9dce;
}
.chengyuancontainer .lookmore span {
  margin-left: 25px;
}
.keyancontainer .lookmore span {
  margin-left: 58px;
}
@media (min-width: 992px) and (max-width: 1199px) {
  .imgwidth_block_over {
    width: 100%;
  }
  .chengyuanlist {
    cursor: pointer;
    width: 140px;
    text-align: center;
    margin: 40px 10px 40px 10px;
  }
  .jianjiecontainer {
    width: 450px;
  }
  .lingyucontainer {
    width: 510px;
    margin-right: auto;
  }
  /* .zuneitopzhong {
    margin-left: 20px;
  } */
  .keyancontainer .lookmore span {
    margin-left: 30px;
  }

  .chengguocontainer {
    width: 992px;
  }
  .dongtaicontainer {
    width: 992px;
  }
  .zongtitle {
    width: 992px;
  }
  .oneblock {
    width: 992px;
  }
  /* .xinwencontainer{ */
  /* display:flex; */
  /* } */
  .xinwenzhongjian {
    width: 310px;
    margin-left: 20px;
  }
  .xinwenzhongjianbottom {
    width: 310px;
    /* margin-left: 20px; */
  }
  .zunei {
    width: 310px;
    margin-left: 20px;
  }
  .zuneitop {
    width: 310px;
  }
  .keyancontainer {
    width: 992px;
  }
  .chengyuancontainer {
    width: 992px;
  }
  .keyanlist {
    /* margin: 40px 30px 10px 30px; */
    margin: 40px 0px 10px 0px;
  }
  .lookmore span {
    margin-left: 0px;
  }
  .chengguocentent {
    width: 420px;
    margin-right: 50px;
  }
  .imgwidth_block_over {
    width: 200px;
    margin: 5px 5px;
  }
  .keyanlist_position_mubu {
    width: -webkit-fill-available;
  }

  .imgwidth {
    width: 100%;
    margin: 0;
    /* height: 250px; */
  }
}
/*在768 和991 像素之间的屏幕里，小屏幕，主要是PAD*/
@media (min-width: 768px) and (max-width: 991px) {
  .keyancontainer .lookmore span {
    margin-left: 58px;
  }
  .chengguocontainer .lookmore span {
    margin-left: 0px;
    display: block;
    /* width: 660px; */
    margin: 0 auto;
  }
  .bottomcontent {
    margin-left: 20px;
  }
  .jianjiecontainer {
    width: 384px;
  }
  .lingyucontainer {
    width: 384px;
    margin-right: 0px;
  }
  .chengguocontainer {
    width: 768px;
  }
  .oneblock {
    width: 768px;
  }
  .chengguocentent {
    width: 768px;
    margin-right: 0px;
  }
  .righttext {
    width: 80%;
    margin: 0 auto;
  }
  .xinwencontainer {
    display: block;
  }
  .xinwenzhongjian,
  .xinwenzhongjianbottom,
  .zunei {
    width: inherit;
  }
  .zuneibottom,
  .xinwenbottom,
  .xinwenzhongjianbottom {
    margin-left: 46px;
  }
  .xinwenzhongjian,
  .xinwenzhongjiantop,
  .zunei {
    margin-left: 0px;
  }
  .chengguomore {
    margin-left: 54px;
    margin-right: 0;
  }
  .dongtaicontainer {
    width: 768px;
  }
  .zongtitle {
    width: 768px;
  }
  .keyancontainer {
    width: 768px;
  }
  .chengyuancontainer {
    width: 768px;
  }
  /* .chengyuancentent {
    justify-content: center;
  } */
  .chengyuanlist {
    cursor: pointer;
    width: 130px;
    text-align: center;
    margin: 40px 10px 40px 10px;
  }
  .lookmore span {
    margin-left: 0px;
    font-size: 12px;
  }
  .titletop .titlefu {
    color: #cccccc;
    font-size: 13px;
    margin-left: 10px;
  }
  .titletop .title {
    font-size: 20px;
    font-weight: 600;
  }
  .titletextfu {
    color: #cccccc;
    font-size: 13px;
    margin-left: 10px;
    text-align: center;
    display: none;
  }
  .titletext {
    display: inline-block;
    font-size: 20px;
    font-weight: 600;
  }
  .keyanlist_position_mubu {
    width: -webkit-fill-available;
  }
  .imgwidth_block_over {
    width: 225px;
  }
  .keyanlist {
    width: 235px;
    margin: 40px 20px 10px 0;
  }
  .imgwidth_block_over {
    width: 212px;
    margin: 5px 5px;
  }
  .imgwidth {
    width: 100%;
    margin: 0;
  }
  .chengguocentent_mubu_text_time .huicolortext {
    font-size: 12px;
  }
  .chengguobottom .chengyuanlist_container {
    font-size: 14px;
  }
}
/*在480 和767 像素之间的屏幕里，超小屏幕，主要是手机*/
@media (min-width: 480px) and (max-width: 767px) {
  .chengguocentent_mubu_text_time .huicolortext {
    font-size: 12px;
  }
  .chengguobottom .chengyuanlist_container {
    font-size: 14px;
  }
  .keyancontainer .lookmore span {
    margin-left: 5px;
  }
  .oneblock {
    display: block;
    margin-top: 30px;
  }
  .bottomcontent {
    margin-left: 20px;
  }
  .jianjiecontainer {
    width: 100%;
    margin: 0 auto;
  }
  .lingyucontainer {
    width: 100%;
    margin: 0 auto;
  }
  .chengguocontainer {
    width: 100%;
  }
  .oneblock {
    width: 100%;
  }
  .chengguocentent {
    width: 100%;
    margin-right: 0px;
  }
  .righttext {
    width: 80%;
    margin: 0 auto;
  }
  .xinwencontainer {
    display: block;
  }
  .xinwenzhongjian,
  .xinwenzhongjianbottom,
  .zunei {
    width: inherit;
  }
  .zuneibottom,
  .xinwenbottom,
  .xinwenzhongjianbottom {
    margin-left: 46px;
  }
  .xinwenzhongjian,
  .xinwenzhongjiantop,
  .zunei {
    margin-left: 0px;
  }
  .chengguomore {
    margin-left: 54px;
    margin-right: 0;
  }
  .dongtaicontainer {
    width: 100%;
  }
  .zongtitle {
    width: 100%;
    margin: 30px auto;
  }

  .keyancontainer {
    width: 100%;
  }
  .keyanlist {
    width: 200px;
    margin: 40px 0 10px 0;
  }
  .imgwidth,
  .imgwidth_block_over {
    width: -webkit-fill-available;
    height: 200px;
  }
  .keyanlist_position_mubu_content {
    font-size: 14px;
  }
  .chengyuancontainer {
    width: 100%;
  }
  /* .chengyuancentent {
    justify-content: center;
  } */
  .chengyuanlist {
    width: 120px;
    margin: 40px auto 40px auto;
  }
  .chengyuanlist img {
    width: 120px;
    height: 120px;
  }

  .lookmore span {
    margin-left: 0px;
    font-size: 12px;
  }
  .chengguotopcontainer {
    font-size: 14px;
    width: initial;
  }
  .textcontent p {
    font-size: 14px;
    line-height: 20px;
  }
  .titletop .title,
  .titletext {
    font-size: 20px;
  }
  .titletop .titlefu,
  .titletextfu,
  .xinwentitle,
  .zuneititle {
    font-size: 16px;
  }
  .chengguotop {
    font-size: 14px;
  }
  .keyanlist_position_mubu {
    height: 200px;
    width: -webkit-fill-available;
  }
  .keyanlist_position_mubu_content {
    line-height: 22px;
    overflow: hidden;
  }
  .onep {
    font-size: 14px;
  }
  .keyanlist p {
    font-size: 14px;
  }
  .FZRJS_font {
    font-size: 14px;
    line-height: 22px;
    letter-spacing: 1px;
  }
  .name_font {
    font-size: 16px;
  }
  .img_width_height {
    width: 120px;
    height: 120px;
    margin-right: 20px;
    float: left;
  }
}
/*在小于480px的屏幕里，微小屏幕，更低分辨率的手机*/
@media (max-width: 479px) {
  .img_width_height {
    width: 120px;
    height: 120px;
    margin-right: 20px;
    float: left;
  }
  .name_font {
    font-size: 16px;
  }
  .FZRJS_font {
    font-size: 14px;
    line-height: 22px;
    letter-spacing: 1px;
  }
  .onep {
    font-size: 14px;
  }

  .keyancontainer .lookmore span {
    margin-left: 0;
  }
  .oneblock {
    display: block;
    margin-top: 30px;
  }
  .bottomcontent {
    margin-left: 20px;
  }
  .jianjiecontainer {
    width: 100%;
    margin: 0 auto;
  }
  .lingyucontainer {
    width: 100%;
    margin: 0 auto;
  }
  .chengguocontainer {
    width: 100%;
  }
  .chengguocentent,
  .xinwen,
  .zunei,
  .xinwenzhongjianbottom {
    width: 90%;
    margin-left: 5%;
  }
  .righttext {
    width: 80%;
    margin: 0 auto;
  }
  .xinwencontainer {
    display: block;
  }
  .xinwenzhongjian,
  .xinwenzhongjianbottom,
  .zunei {
    width: inherit;
  }
  .zuneibottom,
  .xinwenzhongjian,
  .xinwenbottom {
    margin-left: 20px;
  }

  .dongtaicontainer {
    width: 100%;
  }
  .oneblock {
    width: 100%;
  }
  .zongtitle {
    width: 100%;
    margin: 30px auto;
  }

  .keyancontainer {
    width: 100%;
  }
  .chengyuancontainer {
    width: 100%;
  }
  .chengyuancentent,
  .keyancentent {
    justify-content: space-evenly;
  }
  .chengyuanlist {
    margin: 40px auto 40px auto;
  }
  .titletext {
    font-size: 20px;
    /* width: 100px; */
  }
  .titletop .title {
    font-size: 20px;
    /* width: 100px; */
  }
  .titletop .titlefu {
    font-size: 15px;
  }
  .titletextfu {
    display: none;
  }
  .zuneititle,
  .xinwentitle {
    font-size: 18px;
  }
  .textcontent,
  .jianjiecontainer_block {
    width: 90%;
    margin-left: 5%;
  }
  .textcontent p {
    font-size: 14px;
    line-height: 20px;
  }
  .chengguomore {
    margin-left: 5%;
  }
  /* .zuneibottom,
  .xinwenzhongjian,
  .xinwenbottom,
  .titletop {
    width: 90%;
    margin-left: 4%;
  } */
  .keyanlist {
    font-size: 14px;
    width: 145px;
    margin: 40px 0 10px 0;
  }
  .imgwidth,
  .imgwidth_block_over {
    width: initial;
    height: 145px;
  }
  .keyanlist p {
    font-size: 14px;
  }
  .imgwidth {
    width: 100%;
  }
  .huicolortext {
    font-size: 12px;
  }
  .lookmore span {
    margin-left: 0px;
    font-size: 12px;
  }
  .xinwencontainer .lookmore span {
    margin-left: 0px;
  }
  .chengyuanlist {
    width: 130px;
    margin: 40px 0 40px 0;
  }
  .chengyuanlist img {
    width: 120px;
    height: 120px;
  }
  .chengyuanlist_container {
    font-size: 14px;
  }
  .chengguotopcontainer {
    font-size: 14px;
  }
  .chengguotop {
    font-size: 14px;
  }
  .chengguobottom {
    font-size: 12px;
  }
  .onep {
    font-size: 14px;
  }

  .twop {
    font-size: 12px;
    color: #888888;
  }
  .xinwenzhongjian,
  .xinwenzhongjiantop,
  .zunei,
  .zuneitop,
  .zuneitopzhong {
    width: 90%;
  }
  .chengguocentent {
    margin-left: 0px;
    margin-right: 0px;
  }
  .keyanlist_position_mubu {
    height: 145px;
    width: -webkit-fill-available;
  }
  .keyanlist_position_mubu_content {
    font-size: 12px;
    overflow: hidden;
  }
  .maxscreenblock {
    display: none;
  }
  .minscreenblock {
    display: block;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/page/home/homeTemplateTwo.vue